import api from '.'

export async function deleteUser(id: string): Promise<void> {
  await api.delete(`/${id}`)
}
